const apiUrl = process.env.REACT_APP_API_URL;
export const PostInscripcionsFiltrat = async ( json: any, page : string) => {
    try {
        const response = await fetch(`${apiUrl}:8073/inscripcions/filtrat`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'pantalla': page
            },
            body: JSON.stringify(json)
        });
        const jsonData = await response.json();
        return jsonData;
    } catch (error) {
        console.log('Error al obtener los datos:', error);
    }
};
